var DefaultHeader = require("./DefaultHeader");
var postal = require("./PubSub");
var Utils = require("common/Utils");

/**
 * Header implementation used for 'pages' rooted on the options menu
 *
 * @class
 */
function MenuHeader() {
    var bus = postal.channel("NavigationManager");

    var $content = $('<div data-role="header" data-theme="b" class="headerPanel multiHeader" data-tap-toggle="false" data-update-page-padding="false">');

    var $backButton = $('<a href="#" class="backButton" data-role="button" data-icon="mobile-back" data-iconpos="notext" data-inline="true">');
    $backButton.on("click", function() {
        bus.publish("go-back", {});
    });

    var headers = [new DefaultHeader(), new DefaultHeader()];
    headers.forEach(function(header) {
        $content.append(header.getContent());
    });

    /**
     * Return the header content as a jQuery-wrapped element
     *
     * @returns {jQuery} jQuery element containing header content
     */
    this.getContent = function() {
        return $content;
    };

    this.configure = function(configs) {
        var backDisabled = true;

        var i;

        for (i = 0; i < configs.length; i++) {
            // Add back button to the first header
            if (i === 0) {
                if (configs[i].leftButtons) {
                    configs[i].leftButtons.push($backButton);
                } else {
                    configs[i].leftButtons = [$backButton];
                }

                if (configs.last().additionalClasses) {
                    if (configs[i].additionalClasses) {
                        configs[i].additionalClasses += " " + configs.last().additionalClasses;
                    } else {
                        configs[i].additionalClasses = configs.last().additionalClasses;
                    }
                }
            }
            backDisabled &= !!configs[i].disableBackButton;
            headers[i].configure(configs[i]);
            headers[i].show();
        }

        Utils.setElementEnabled($backButton, !backDisabled);

        // Hide any headers that we aren't using
        for (; i < headers.length; i++) {
            headers[i].hide();
        }
    };

    this.setNumColumns = function(count) {
        for (var i = 0; i < headers.length; i++) {
            headers[i].getContent().toggle(i < count);
        }
    };

    this.show = function() {
        $content.show();
    };

    this.hide = function() {
        $content.hide();
    };
}

module.exports = MenuHeader;


//////////////////
// WEBPACK FOOTER
// ./common/MenuHeader.js
// module id = 5
// module chunks = 3 4